import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ReadonlyAwareInputs";
import { resetGroupDataSync } from "../services/storage/groupDataStorage";
import { setCachedLocation } from "../store/slice/usageInfoSlice";

const AlreadyOpen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onSetCurrentTabAsActive = () => {
    localStorage.removeItem("activeTab");
    localStorage.removeItem("json");
    resetGroupDataSync();
    dispatch(setCachedLocation("/"));

    navigate("/");
  };

  return (
    <>
      <div style={{ textAlign: "center", padding: "50px" }}>
        <h1>App Already Open</h1>
        <p>
          This application is already open in another tab. Please use that tab
          or close it to continue here.
        </p>
      </div>
      <Button
        onClick={onSetCurrentTabAsActive}
        style={{
          position: "absolute",
          right: "20px",
          top: "50%",
          transform: "translateY(-50%)",
          padding: "10px 20px",
          cursor: "pointer",
        }}
      >
        Switch to This Tab
      </Button>
    </>
  );
};

export default AlreadyOpen;
